export enum IrpfRetentionPercentageTypeEnum {
    fifteen = "15",
    seven = "7"
}


export class IrpfRetentionPercentageType {
    constructor(
        public readonly id: IrpfRetentionPercentageTypeEnum,
        public readonly label: string,
    ) { }
}